import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVectorUseCases } from "../../../store/slices/policiesSlice";
import { Loading } from "../../common";
import "../../../pages/Policies/policies.css"
const EMPTY_ARRAY = [];
const AttackVectorCard = ({ vector, isDefaultOpen, onUseCaseClick }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  
  const useCases = useSelector(state => 
    state.policies.useCasesByVector[vector?.vector_id]
  ) || EMPTY_ARRAY;

  const loadingStatus = useSelector(state => 
    state?.policies?.useCasesLoadingStatus[vector?.vector_id]
  );

  useEffect(() => {
    setOpen(isDefaultOpen);
  }, [isDefaultOpen]);

  useEffect(() => {
    if (open && !loadingStatus) {
      dispatch(fetchVectorUseCases(vector?.vector_id));
    }
  }, [open, vector?.vector_id, loadingStatus, dispatch]);

  return (
    <div className={`policy-card-new ${open ? 'is-open' : ''}`}>
      <div className="policy-card-header" onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
        <div>
          <h4>{vector.attack_vector_name.replace(/_/g, " ")}</h4>
          <p>{vector.max_total_flagged} max total identities • Risk Weight: {vector.risk_weight}</p>
        </div>
        {/* <div className="vector-id-badge">{vector.vector_id}</div> */}
      </div>

      {open && (
        <div className="usecase-list scrollable-usecases">
          {loadingStatus === 'loading' ? (
            <Loading text="loading rules" size="sm"/>
          ) :useCases.length === 0 ? (
            <div className="no-usecases-message" style={{ padding: '15px', color: '#666', textAlign: 'center' }}>
              No use cases found for this attack vector.
            </div>
          ) : (
            useCases.map((uc, i) => (
              <div key={i} className="usecase-item" onClick={(e) => {
                e.stopPropagation();
                onUseCaseClick(uc);
              }}>
                <div className="usecase-header">
                  <strong>{uc.usecase_name}</strong>
                  <span className="count-badge">{uc.total_identities} identities</span>
                </div>
                <div className="usecase-reason">{uc.description || "No description provided."}</div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default AttackVectorCard;